import React from "react";

export default function Testimonial() {
  return (
    <div>
      <h1>Oops, something went wrong, </h1>
      <p>
        <a href="/">Home</a>
      </p>
    </div>
  );
}
